<template>
  <div class="footer">
    <img class="logo img-fluid" src="../assets/logo_white.png" />
    <h3 class="heading">Delivery</h3>
    <h4 class="heading d-none">Lunes a Sabado de 16:00 hrs. - 00:00 hrs</h4>
    <p class="heading">Desarrollado por <a href="http://sglimitada.cl" target="_blank">SG Limitada</a></p>
  </div>
</template>

<style scoped>
  .footer {
    background: url('../assets/images/home-1-footer.jpg') center center;
    min-height: 800px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .footer  .logo{
    max-width: 600px;
    width: 100%;
    height: auto;
    margin: 0px 0px;
    display: block;
    margin: 30px 0;
  }
  .footer h3 {
    display: block;
  }
  @media only screen and (max-width: 600px) {
    .footer .logo {
      width: 60%;
    }
  }
</style>

<script>
export default {
  
}
</script>